import { render, staticRenderFns } from "./IOTDataFMS.vue?vue&type=template&id=64aff794"
import script from "./IOTDataFMS.vue?vue&type=script&lang=js"
export * from "./IOTDataFMS.vue?vue&type=script&lang=js"
import style0 from "./IOTDataFMS.vue?vue&type=style&index=0&id=64aff794&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports